import * as localStorage from './tools/storage';
import axios from 'axios';
export const isDev = process.env.NODE_ENV === 'development' || localStorage.getItem('isdev');
export function getHttpClient(website_match){
	return axios.create({
		baseURL:getServer(),
		headers:buildHeaders(website_match)
	})
}

var access_token = null
export function getAccessToken(){
	return access_token ||
			sessionStorage.getItem('access_token') ||
			localStorage.getItem('access_token')
}
export function setAccessToken(token, inSessionOnly = false){
	access_token = token;
	if(inSessionOnly){
		sessionStorage.setItem('access_token', token)
	}else{
		localStorage.setItem('access_token', token)
	}
}

export function removeAccessToken(){
	access_token = null;
	sessionStorage.removeItem('access_token')
	localStorage.removeItem('access_token')
}
function getServer(){
	if(isDev){
		return 'https://api-server-3.goaffpro.com'
	}else{
	   return 'https://api2.goaffpro.com'
	}
}

export const apiServer = getServer();
export const apiUrl = getServer()+'/partner'
export function buildUri(endpoint, query){
	const baseUri = endpoint && endpoint.substr(0,8) === "https://" ? endpoint : `${apiUrl}${endpoint}`;
	if (query) {
		const u = new URL(baseUri);
		Object.keys(query).forEach((item) => {
			if (query[item] !== undefined) {
				u.searchParams.append(item, query[item]);
			}
		});
		return u.href;
	}
	return baseUri;

}

export function post(endpoint, data){
	const headers = buildHeaders();
	headers['content-type'] = 'application/json';
	return fetch(buildUri(endpoint), {
		method: 'POST',
		credentials: 'include',
		headers,
		body: JSON.stringify(data)
	}).then((data) =>{
		console.log(data.status);
		return data.json();
	})
}

export function patch(endpoint, data){
	const headers = buildHeaders();
	headers['content-type'] = 'application/json';
	return fetch(buildUri(endpoint), {
		method: 'PATCH',
		credentials: 'include',
		headers,
		body: JSON.stringify(data)
	}).then((data) =>{
		console.log(data.status);
		return data.json();
	})
}

export function upload(endpoint, body){
	const headers = buildHeaders();
	return fetch(buildUri(endpoint), {
		method: 'POST',
		credentials: 'include',
		headers,
		body
	}).then((data) => data.json());
}

export function buildHeaders(xShop){
	const headers =  {
	};
	if(getAccessToken()) {
		headers.Authorization = `Bearer ${getAccessToken()}`
	}

	if (isDev){
		headers['x-shop'] = 'helloworld.goaffpro.com';
	}
	if(localStorage.getItem('x-shop')){
		headers['x-shop'] = localStorage.getItem('x-shop');
	}
	if(xShop){
		headers['x-shop'] = xShop
	}
	return headers;
}



export function get(endpoint, query, abortController){
	const headers = buildHeaders();
	headers['content-type'] = 'application/json';
	return fetch(buildUri(endpoint, query),{
		method: 'GET',
		signal: abortController ? abortController.signal : undefined,
		credentials: 'include',
		headers,
	}).then((response) => {
		if (response.ok){
			return response;
		}else if(response.status === 403) {
			removeAccessToken()
		}else {
			throw response
		}
	}).then((data) => data ? data.json() : {});
}

export function del(endpoint){
	return fetch(buildUri(endpoint),{
		method: 'DELETE',
		credentials: 'include',
		headers: buildHeaders()
	}).then((response) => {
		if (response.ok){
			return response;
		}
		throw new Error(response.status);

	}).then((data) => data.json());
}
